export enum FeesOptions {
    percentage = 'Percentage',
    nominal = 'Nominal',
}

export const feesOptions = [FeesOptions.percentage, FeesOptions.nominal];
